import { useControllerApi, useQueryWrapper } from "@repo/baseCloud";

import ApiRoute from "./apiRoute";

export function useLocationPortalApi(controller = ApiRoute) {
	return useControllerApi(controller);
}

export { useQueryWrapper };
